/* ================================================
   VALERO — Complete JS
   ================================================ */
(function () {
  'use strict';

  /* ── Reveal on scroll ── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nt-reveal]').forEach(function (el) {
        el.classList.add('revealed');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-nt-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ── Sticky header shadow ── */
  function initHeader() {
    var h = document.querySelector('.nt-header');
    if (!h) return;
    window.addEventListener('scroll', function () {
      h.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Scroll to top ── */
  function initScrollTop() {
    var btn = document.getElementById('nt-scroll-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Mobile menu ── */
  function initMobileMenu() {
    var btn = document.getElementById('nt-menu-btn');
    var overlay = document.getElementById('nt-mobile-menu');
    var close = document.getElementById('nt-menu-close');
    if (!btn || !overlay) return;
    function open() { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeMenu() { overlay.classList.remove('open'); document.body.style.overflow = ''; }
    btn.addEventListener('click', open);
    if (close) close.addEventListener('click', closeMenu);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ── Product gallery thumbnails ── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.nt-product-gallery__thumb');
    var mainImg = document.querySelector('.nt-product-gallery__main img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.querySelector('img').src;
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  /* ── Quantity selector ── */
  function initQty() {
    document.querySelectorAll('.nt-qty-selector').forEach(function (sel) {
      var inp = sel.querySelector('.nt-qty-input');
      var minus = sel.querySelector('[data-minus]');
      var plus = sel.querySelector('[data-plus]');
      if (!inp) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) || 1;
        if (v > 1) inp.value = v - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(inp.value, 10) || 1;
        inp.value = v + 1;
      });
    });
  }

  /* ── Option pills ── */
  function initOptionPills() {
    document.querySelectorAll('.nt-option-pills').forEach(function (group) {
      group.querySelectorAll('.nt-option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.nt-option-pill').forEach(function (p) { p.classList.remove('selected'); });
          pill.classList.add('selected');
        });
      });
    });
  }

  /* ── Add to cart feedback ── */
  function initAddToCart() {
    document.querySelectorAll('.nt-btn--atc, .product-form__submit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var orig = btn.textContent.trim();
        btn.classList.add('added');
        btn.textContent = 'Ajouté au panier ✓';
        setTimeout(function () {
          btn.classList.remove('added');
          btn.textContent = orig;
        }, 2500);
      });
    });
  }

  /* ── Countdown timer ── */
  function initCountdowns() {
    document.querySelectorAll('[data-nt-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.ntCountdown);
      var vals = el.querySelectorAll('.nt-countdown-block__val');
      if (!vals.length) return;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { vals.forEach(function (v) { v.textContent = '00'; }); return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var parts = [d, h, m, s];
        vals.forEach(function (v, i) { if (parts[i] !== undefined) v.textContent = pad(parts[i]); });
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ── Newsletter submit ── */
  function initNewsletter() {
    document.querySelectorAll('.nt-newsletter__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('button[type="submit"]');
        var input = form.querySelector('.nt-newsletter__input');
        if (!btn || !input || !input.value.trim()) return;
        e.preventDefault();
        var orig = btn.textContent;
        btn.textContent = 'Merci ! 🎉';
        btn.style.background = '#10b981';
        input.value = '';
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
        }, 4000);
      });
    });
  }

  /* ── Product card quick-add ── */
  function initQuickAdd() {
    document.querySelectorAll('.nt-product-card__quick-add .nt-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var orig = btn.textContent;
        btn.textContent = '✓ Ajouté';
        btn.style.background = '#10b981';
        btn.style.borderColor = '#10b981';
        btn.style.color = '#fff';
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
          btn.style.borderColor = '';
          btn.style.color = '';
        }, 2000);
      });
    });
  }

  /* ── Mobile filter drawer ── */
  function initMobileFilters() {
    var toggleBtn = document.getElementById('nt-filter-toggle');
    var overlay = document.getElementById('nt-filter-drawer-overlay');
    var closeBtn = document.getElementById('nt-filter-drawer-close');
    if (!toggleBtn || !overlay) return;
    function openDrawer() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
    toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ── Sticky ATC bar ── */
  function initStickyAtc() {
    var bar = document.getElementById('nt-sticky-atc-bar');
    var mainAtcBtn = document.querySelector('#nt-product-form button[type="submit"]');
    var stickyBtn = bar ? bar.querySelector('.nt-sticky-atc-bar__btn') : null;
    if (!bar || !mainAtcBtn) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0.1 });
    io.observe(mainAtcBtn);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAtcBtn.click();
        var orig = stickyBtn.textContent;
        stickyBtn.textContent = 'Ajouté ✓';
        stickyBtn.style.background = '#10b981';
        setTimeout(function () {
          stickyBtn.textContent = orig;
          stickyBtn.style.background = '';
        }, 2500);
      });
    }
  }

  /* ── Announcement bar close ── */
  function initAnnouncement() {
    var closeBtn = document.querySelector('[data-nt-close-announcement]');
    var bar = document.querySelector('.nt-announcement');
    if (!closeBtn || !bar) return;
    closeBtn.addEventListener('click', function () {
      bar.style.height = bar.offsetHeight + 'px';
      bar.style.overflow = 'hidden';
      bar.style.transition = 'height 0.3s ease, padding 0.3s ease, opacity 0.3s ease';
      requestAnimationFrame(function () {
        bar.style.height = '0';
        bar.style.padding = '0';
        bar.style.opacity = '0';
      });
      setTimeout(function () { bar.remove(); }, 350);
    });
  }

  /* ── Init all ── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
    initScrollTop();
    initMobileMenu();
    initGallery();
    initQty();
    initOptionPills();
    initAddToCart();
    initCountdowns();
    initNewsletter();
    initQuickAdd();
    initAnnouncement();
    initMobileFilters();
    initStickyAtc();
  });
})();